module.exports = __webpack_public_path__ + "img/roles.a0ca9f15.svg";